import { render, staticRenderFns } from "./ResultsListEventItem.vue?vue&type=template&id=1b9929a5"
import script from "./ResultsListEventItem.vue?vue&type=script&lang=js"
export * from "./ResultsListEventItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports